import { createReducer } from 'lib/redux/reducerUtils'
import { FlightsFareTypes } from 'constants/flight'
import type { ValueOf } from 'type-fest'
import { fillArray } from 'lib/array/arrayUtils'

export enum StandaloneFlightsActions {
  RE_INITIALISE = 'RE_INITIALISE',
  UPDATE_PASSENGER_BAGGAGE = 'UPDATE_PASSENGER_BAGGAGE',
  SET_VIEW_TYPE = 'SET_VIEW_TYPE',
}

export interface StandaloneFlightsState {
  isFlightSelectError: boolean
  passengers: Array<App.Passenger>
  viewType?: string
  fareType: FlightsFareTypes
  segments: Array<string>
  activeSegmentKey: string
  flightAirports: Record<string, { origin: App.Airport, destination: App.Airport }>
  selectedFlights: Record<string, App.JourneyV2>
  selectedFareFamilies: Record<string, App.FlightFareFamily>
  selectedPointsCalculationRequests: Record<string, Array<App.LoyaltyPointsEarnCalculationRequest | undefined>>
  /** Whether the search's traveller mix includes a child or infant alongside an adult. */
  isMixedTravellerSearch: boolean
}

export type StandaloneFlightsAction = ValueOf<Utils.FullActionMap<{
  [StandaloneFlightsActions.RE_INITIALISE]: { initialState: Partial<StandaloneFlightsState> }
  [StandaloneFlightsActions.UPDATE_PASSENGER_BAGGAGE]: { journeyId: string, baggage: Array<Array<App.AddedBaggage>> }
  [StandaloneFlightsActions.SET_VIEW_TYPE]: { viewType: string }
}>>

export const initialState: StandaloneFlightsState = {
  passengers: [],
  isFlightSelectError: false,
  viewType: undefined,
  fareType: FlightsFareTypes.RETURN,
  segments: [],
  activeSegmentKey: '',
  flightAirports: {},
  selectedFareFamilies: {},
  selectedFlights: {},
  selectedPointsCalculationRequests: {},
  isMixedTravellerSearch: false,
}

export function createStandaloneFlightSegmentsKeys(flights: number, segmentSeed: string) {
  return fillArray(flights).map((_, index) => `${segmentSeed}-${index}`)
}

const standaloneStateReducer = createReducer<StandaloneFlightsState, StandaloneFlightsAction>(initialState, {
  [StandaloneFlightsActions.RE_INITIALISE]: (_state, action) => ({
    ...initialState,
    ...action.initialState,
  }),
  [StandaloneFlightsActions.UPDATE_PASSENGER_BAGGAGE]: (state, action) => ({
    passengers: state.passengers.map((passenger, index) => ({
      ...passenger,
      addedExtras: {
        carryOnBaggage: {},
        ...passenger.addedExtras,
        baggage: {
          ...passenger.addedExtras?.baggage,
          [action.journeyId]: action.baggage[index],
        },
      },
    })),
  }),
  [StandaloneFlightsActions.SET_VIEW_TYPE]: (_state, action) => ({
    viewType: action.viewType,
  }),
})

export default standaloneStateReducer
